module.exports = __webpack_public_path__ + "static/media/brainpicture.de745810.png";